export default "__VITE_ASSET__BiD89SsF__"